import { useEffect, useState } from "react";
import { Maximize2, Minimize2 } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";

export function FullscreenToggle() {
  const { t } = useTranslation();
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleChange = () => setIsFullscreen(Boolean(document.fullscreenElement));
    document.addEventListener("fullscreenchange", handleChange);
    return () => document.removeEventListener("fullscreenchange", handleChange);
  }, []);

  const toggle = async () => {
    if (document.fullscreenElement) {
      await document.exitFullscreen();
      return;
    }
    await document.documentElement.requestFullscreen();
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={t.shell.fullscreen}
      className="rhythm-icon-btn"
    >
      {isFullscreen ? <Minimize2 size={18} /> : <Maximize2 size={18} />}
    </button>
  );
}
